module.exports = __webpack_public_path__ + "static/media/Programing_Services_patrat_36kb.37dcfa81.png";